import { Entity, bridge } from "@dinahmoe/dmafjs-core";

class WebAudioSuper extends Entity {
  namespace = "webaudio";
  engine = "webaudio";

  init(node) {
    const data = this.getInitData(node);
    bridge.create({ ...data, uid: "webaudio/" + data.uid, sender: "core" });
  }
}

const webAudioSuper = new WebAudioSuper();
export { webAudioSuper, WebAudioSuper };
